import React, { useEffect, useRef, useState } from 'react';
import Button from '../../../../../component/ui/Button';
import GeneralInvoice from './components/general';
import InvoiceFieldCustomisation from './components/invoiceFieldCustomisation';
import { toast } from 'react-toastify';
import timer from '../../../../../assets/image/timer.svg';
import {
	getInvoiceGeneral,
	invoicePasswordVerifyOtp,
	sendInvoicePasswordOtp,
	UpdateInvoiceGeneral,
} from '../../../../../services/settings/sales';
import { stringToBool } from '../../../../../utils/utility';
import Modal from '../../../../../component/modal/Modal';
// import { useSelector } from 'react-redux';
import OTPInput from 'react-otp-input';
import { useNavigate } from 'react-router-dom';

export default function SettingsInvoices({ activeTab }) {
	const [invoiceTab, setInvoiceTab] = useState('General');
	// const user = useSelector((state) => state?.userInfo?.userInfo?.data);
	const [isEdit, setIsEdit] = useState(false);
	const [isCreateForm, setIsCreateForm] = useState(false);
	const [isOtpLoading, setOtpLoading] = useState(false);
	const [otp, setOtp] = useState('');
	const [invoicePassword, setInvoicePassword] = useState('');
	const [isOpenModal, setIsOpenModal] = useState(false);
	const otpRefs = useRef([]);
	const navigate = useNavigate();
	const [timeLeft, setTimeLeft] = useState(0);
	const [loader, setLoader] = useState({
		isLoader: true,
		isSave: false,
		isGetData: true,
		isGetDataFieldCustomisation: true,
		isSaveFieldCustomisation: true,
	});
	const [customFieldError, setCustomFieldError] = useState(false);
	const [error, setError] = useState({});
	const [customFieldForm, setCustomFieldForm] = useState({
		label_name: '',
		data_type: '',
		status: false,
		is_mandatory: false,
	});
	const [generalForm, setGeneralForm] = useState({});
	const [form, setForm] = useState({
		allow_editing_sales_invoice: false,
		allow_editing_sent_invoice: false,
		invoice_password: '',
		print_payment_qr_code: false,
		payment_notification_to_owner: false,
		payment_received_notification_to_customer: false,
		terms_and_conditions: '',
		customer_notes: '',
	});

	const getShowUndoChanged = () => {
		const hasChanged = JSON.stringify(generalForm) !== JSON.stringify(form);
		setIsEdit(hasChanged);
	};
	const handleGeneralInvoice = async (authoToken = '') => {
		try {
			setLoader((prev) => ({
				...prev,
				isLoader: true,
				isSave: true,
			}));
			setIsEdit(false);
			const res = await UpdateInvoiceGeneral(form, authoToken);
			if (res.success) {
				toast.success(res.message);
				navigate(0);
				getGeneralInvoices();
			} else {
				setIsEdit(true);
				toast.error(res.message);
			}
		} catch (error) {
			setIsEdit(true);
		} finally {
			setLoader((prev) => ({
				...prev,
				isLoader: false,
				isSave: false,
			}));
		}
	};

	const formatTime = (seconds) => {
		const minutes = Math.floor(seconds / 60);
		const remainingSeconds = seconds % 60;
		return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
	};

	const handleOtpChange = (otp) => {
		setOtp(otp);
		const nextInputIndex = otp.length;
		if (nextInputIndex < otpRefs.current.length) {
			otpRefs.current[nextInputIndex].focus();
		}
	};

	const handleSendOTP = async () => {
		try {
			setOtpLoading(true);
			setOtp('');
			setTimeLeft(0);
			// let body = {
			// 	email: user?.emaill || '',
			// };
			if (timeLeft === 0 || !isOpenModal) {
				const res = await sendInvoicePasswordOtp();
				if (res?.success) {
					const nextInputIndex = otp.length;
					if (nextInputIndex < otpRefs.current.length) {
						otpRefs.current[nextInputIndex].focus();
					}
					toast.success(res?.message);
					setTimeLeft(5 * 60);
					setOtpLoading(false);
				}
			} else {
				toast.error('Please wait for the timer to end.');
				setOtpLoading(false);
			}
		} catch (error) {
			toast.error(error.message || 'Something went wrong!');
		}
	};
	const handleKeyDown = (event) => {
		if (event.key === 'Enter') {
			handleVerifyOTP();
		} else if (event.key === 'Backspace') {
			const currentIndex = otpRefs.current.findIndex((el) => document.activeElement === el);
			if (currentIndex > 0) {
				event.preventDefault();
				setOtp((prevOtp) => prevOtp.slice(0, -1));
				otpRefs.current[currentIndex - 1].focus();
			}
		}
	};

	const handleVerifyOTP = async () => {
		try {
			let body = {
				otp: otp,
			};
			const res = await invoicePasswordVerifyOtp(body);
			if (res.success) {
				setIsOpenModal(false);
				if (res?.data?.invoice_edit_token) {
					handleGeneralInvoice(res?.data?.invoice_edit_token);
				} else {
					toast.error('Otp verification token is missing');
				}
			} else {
				toast.error(res.message);
			}
		} catch (error) {
			toast.error(error.message || 'Something went wrong!');
		}
	};

	const getGeneralInvoices = async () => {
		try {
			setLoader((prev) => ({
				...prev,
				isLoader: true,
				isGetData: true,
			}));

			const { invoice_settings } = await getInvoiceGeneral();
			var data = {
				allow_editing_sales_invoice:
					invoice_settings.allow_editing_sales_invoice !== null
						? stringToBool(invoice_settings.allow_editing_sales_invoice)
						: true,
				allow_editing_sent_invoice:
					invoice_settings.allow_editing_sent_invoice !== null &&
					invoice_settings.allow_editing_sent_invoice !== undefined
						? stringToBool(invoice_settings.allow_editing_sent_invoice)
						: false,
				invoice_password:
					invoice_settings.invoice_password !== null ? invoice_settings.invoice_password : '',
				print_payment_qr_code:
					invoice_settings.print_payment_qr_code !== null
						? stringToBool(invoice_settings.print_payment_qr_code)
						: false,
				payment_notification_to_owner:
					invoice_settings.payment_notification_to_owner !== null
						? stringToBool(invoice_settings.payment_notification_to_owner)
						: false,
				payment_received_notification_to_customer:
					invoice_settings.payment_received_notification_to_customer !== null
						? stringToBool(invoice_settings.payment_received_notification_to_customer)
						: false,
				terms_and_conditions:
					invoice_settings.terms_and_conditions !== null
						? invoice_settings.terms_and_conditions
						: '',
				customer_notes:
					invoice_settings.customer_notes !== null ? invoice_settings.customer_notes : '',
			};
			setForm(data);
			setGeneralForm(data);
			setInvoicePassword(
				invoice_settings.invoice_password !== null ? invoice_settings.invoice_password : '',
			);
		} catch (error) {
			toast.error(error.message || 'Something went wrong!');
		} finally {
			setLoader((prev) => ({
				...prev,
				isLoader: false,
				isGetData: false,
			}));
		}
	};

	const handleCustomField = () => {};
	useEffect(() => {
		if (timeLeft <= 0) return;
		const intervalId = setInterval(() => {
			setTimeLeft((prevTime) => prevTime - 1);
		}, 1000);

		return () => clearInterval(intervalId);
	}, [timeLeft]);
	useEffect(() => {
		if (form) {
			getShowUndoChanged();
		}
	}, [form]);

	useEffect(() => {
		getGeneralInvoices();
	}, []);

	return (
		<div>
			<div style={{ backgroundColor: '#EDEDF7', position: 'sticky', top: 0, zIndex: 100 }}>
				<div className="d-flex py-3 px-2 justify-content-between align-items-center">
					<div className="fs-4 fw-semibold">{activeTab}</div>
					<div className="d-flex gap-3">
						{invoiceTab === 'Field Customisation' ? (
							<Button
								type="button"
								className="mt-0 btn-primary fs-5 fw-light add-pro py-1"
								button="Add New Custom Field"
								add
								onClick={() => setIsCreateForm(true)}
							/>
						) : (
							<>
								<Button
									type="button"
									className="btn-primary mt-0 fs-5 fw-light add-pro py-1 px-4"
									button="Save"
									disabled={!isEdit}
									onClick={() => {
										var newError = { ...error };
										if (
											form.allow_editing_sales_invoice &&
											(form.invoice_password === '' ||
												form.invoice_password === undefined ||
												form.invoice_password === null)
										) {
											newError.invoice_password = 'Please enter password in the field.';
											setError(newError);
										} else if (
											form.allow_editing_sales_invoice &&
											invoicePassword !== form.invoice_password
										) {
											setIsOpenModal(true);
											handleSendOTP();
										} else {
											handleGeneralInvoice();
										}
									}}
									loader={loader.isLoader && loader.isSave}
								/>
								{isEdit && (
									<Button
										type="button"
										className="btn-primary mt-0 fs-5 fw-light add-pro py-1 px-4"
										button="Undo Changed"
										onClick={() => {
											setIsEdit(false);
											getGeneralInvoices();
										}}
									/>
								)}
							</>
						)}
					</div>
				</div>
			</div>
			<div
				className="py-2 d-flex justify-content-between align-items-center"
				style={{
					backgroundColor: '#DADDEC',
					position: 'sticky',
					top: '52px',
					zIndex: 100,
					overflow: 'hidden',
				}}
			>
				<div>
					<ul className="nav mt-2">
						{['General', 'Field Customisation'].map((item, index) => (
							<li
								key={index}
								className="nav-item"
							>
								<div
									className={`tab-link ${invoiceTab === item ? 'active' : ''} d-flex align-items-center`}
									onClick={() => {
										setInvoiceTab(item);
										setIsCreateForm(false);
									}}
								>
									{item}
								</div>
							</li>
						))}
					</ul>
				</div>
				{isCreateForm && (
					<div className="d-flex gap-4 align-items-center px-2">
						<div
							className="bg-blue py-2 px-4 text-white fs-5 fw-light rounded-4 cursor-pointer"
							style={{ backgroundColor: '#0066ff' }}
							onClick={() => handleCustomField()}
						>
							Save
						</div>
						<div
							className="bg-blue py-2 px-4 text-white fs-5 fw-light rounded-4 cursor-pointer"
							style={{ backgroundColor: '#555B67' }}
							onClick={() => setIsCreateForm(false)}
						>
							Cancel
						</div>
					</div>
				)}
			</div>
			{invoiceTab === 'General' ? (
				<GeneralInvoice
					form={form}
					setForm={setForm}
					error={error}
					setError={setError}
					loader={loader}
				/>
			) : (
				<InvoiceFieldCustomisation
					isCreateForm={isCreateForm}
					setIsCreateForm={setIsCreateForm}
					setCustomFieldForm={setCustomFieldForm}
					customFieldForm={customFieldForm}
					setCustomFieldError={setCustomFieldError}
					customFieldError={customFieldError}
				/>
			)}

			{isOpenModal && (
				<Modal
					className="invoice-otp-modal"
					title={`Verification Required`}
					isOpen={isOpenModal}
					onClose={() => {
						setIsOpenModal(false);
						setIsEdit(false);
					}}
					cancelButton={() => {
						setIsOpenModal(false);
						setIsEdit(false);
					}}
				>
					<div
						style={{
							textAlign: 'center',
							backgroundColor: '#E6F5FF',
							padding: '20px 10px',
							marginBottom: '20px',
							borderRadius: '5px',
							fontWeight: '600',
							color: 'black',
						}}
					>
						An OTP has been sent to your registered email. Please verify to confirm enabling invoice
						editing.
					</div>
					<span className="invoice-enter-otp my-5 py-3">
						<OTPInput
							value={otp}
							onChange={handleOtpChange}
							numInputs={4}
							renderSeparator={<span></span>}
							isInputNum={true}
							autoFocus={true}
							renderInput={(props, index) => (
								<input
									{...props}
									ref={(el) => (otpRefs.current[index] = el)}
									onKeyDown={handleKeyDown}
								/>
							)}
						/>
					</span>
					<div className="d-flex align-items-center justify-content-center gap-4 mt-4">
						<Button
							type="button"
							className="mt-0 px-5 btn-primary relative"
							button="Verify OTP"
							onClick={handleVerifyOTP}
							disabled={otp.length !== 4}
						></Button>
					</div>
					{timeLeft > 0 && (
						<div className="invoice-timer-body">
							<span className="invoice-timer">
								<img
									className="align-top me-2"
									src={timer}
									alt="timer"
								/>
								{formatTime(timeLeft)}
							</span>
						</div>
					)}
					{timeLeft === 0 && !isOtpLoading && (
						<p className="mt-5 mb-3 text-center">
							Didn’t receive the code?{' '}
							<span className="primary-color cursor-pointer">
								{
									<a
										className="font-bold"
										onClick={handleSendOTP}
									>
										Resend Code
									</a>
								}
							</span>
						</p>
					)}
					<div className="d-flex align-items-center justify-content-end gap-4 mt-4">
						<Button
							type="button"
							button={'Ok'}
							className="mt-0 px-5 btn-primary relative"
							onClick={() => setIsOpenModal(false)}
						/>
					</div>
				</Modal>
			)}
		</div>
	);
}
